import React, { useEffect, useRef, useState } from "react";
import DownArrow from "./../../assets/images/down-arrow.svg";
import ProfileImg from "./../../assets/images/profileImage.png";
import { NavLink, useLocation, useNavigate } from 'react-router-dom'; // Import Link from react-router-dom
import Dialog from "@mui/material/Dialog";
import "./WalletInfo.scss";
import API from "../../services";
import { toast } from "react-toastify";
import { showNotificationToast } from "../../utils/notificationToast";
import { RootState } from "../../models/RootState";
import { connect } from "react-redux";
import { setUserDetails, setWallets, setActiveWallet, setUserThumbnail } from "../../store/authReducer";
import { UserDetails } from "../../models/UserDetails";
import Logo from "../../assets/images/stikelogo.svg";
import { themes } from "./MyProfile/MyProfile";
import { checkTelegramWebApp, loadColorConfig, telegramWebApp } from "../../constants/common";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SupportIcon from "../../assets/images/support.svg";
import { FaBell, FaChevronDown, FaFacebook, FaInstagram, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import { SiteConfig } from "../../models/SiteConfig";
import { connectToNotificationWS, WebSocketEvent } from "../../websockets/webSocket";
import { BannerNavigation } from "../../store/authActions";
import { getBaseUrl } from "../../services/environment-url";
import { useTranslation } from "../../hooks/useTranslation";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import IconButton from "@mui/material/IconButton";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { domain } from "../../constants/Branding";
import { getEnvVariable } from "../../constants/whitelabelEnv";
import { demoUser } from "../../utils/StringUtils";

const WhiteLabelLogo = getEnvVariable(domain, 'logo');
const BRAND_NAME = getEnvVariable(domain, 'BRAND_NAME');

type WalletInfoProps = {
  balance: string;
  setUserDetails: (data: any) => void;
  setWallets: (data: any) => void;
  userDetails: UserDetails;
  setActiveWallet: (data: any) => void;
  wallets: any;
  activeWallet: any;
  setUserThumbnail: (data: any) => void;
  userThumbnail: any;
  Browser: any;
  dynamicTextColors?: any;
};

interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  language_code?: string;
}

interface TelegramInitDataUnsafe {
  query_id?: string;
  user?: TelegramUser;
  auth_date?: number;
  hash?: string;
}

const WalletInfo: React.FC<
  WalletInfoProps & { siteConfig: SiteConfig }
> = ({
  balance,
  setUserDetails,
  setWallets,
  userDetails,
  setActiveWallet,
  wallets,
  activeWallet,
  userThumbnail,
  setUserThumbnail, Browser,
  siteConfig,
  dynamicTextColors,
}) => {
  const { t } = useTranslation();
  const [showBalInfo, setShowBalInfo] = useState<any>(false);
  const [userAllBalance, setUserAllBalance] = useState<any>(null);
  const [selectedBalance, setSelectedBalance] = useState<any>();
  const [nonZeroBalance, setNonZeroBalance] = useState<any>();
  const [hideZeroBalances, setHideZeroBalances] = useState(true);
  const [hasFetchedBalanceOnce, setHasFetchedBalanceOnce] = useState(false);
  const [user, setUser] = useState<TelegramUser | null>(null);
  const [showContactBar, setShowContactBar] = useState(false);
  const [hasNotifications, setHasNotifications] = useState(false);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const [showNotificationPreview, setShowNotificationPreview] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const notificationWSConnected = useRef(false);
  const contactBarRef = useRef<HTMLDivElement | null>(null);
  const notificationBellRef = useRef<HTMLDivElement | null>(null);
  const isWhatsAppPriorityBrand = ["hindu777", "big7"].includes(
    (BRAND_NAME || "").toLowerCase()
  );
  const [withdrawableAmount, setWithdrawableAmount] = useState<number>(0);
  const [redeemableBonus, setRedeemableBonus] = useState<number>(0);

  const path = location?.pathname

  const bigb7WhatsAppContactDetails = "https://wa.me/919911976868?text"

  const hindu777WhatsAppContactDetails = "https://wa.link/hindu7"

  const isDualWalletBalanceBrand = ["khelo365days", "momowin777"].includes((BRAND_NAME || "").toLowerCase());

  const walletsForDisplay = isDualWalletBalanceBrand ? (hasFetchedBalanceOnce ? wallets : []) : wallets;
  const balWallet = walletsForDisplay?.find((w: any) => w?.walletName === "POINTS");
  const playChipsWallet = walletsForDisplay?.find((w: any) => w?.walletName === "PLAY_CHIPS");
  const rewardWallet = walletsForDisplay?.find((w: any) => w?.walletName === "REWARD");
  const secondaryWallet = playChipsWallet || rewardWallet;
  const hasPlayChipsWallet = wallets?.some((w: any) => w?.walletName === "PLAY_CHIPS");

  // Get dynamic text color classes from Redux instead of calling function
  const inputBoxTextColorClass = dynamicTextColors?.inputBoxTextColorClass || '';
  const headerTextColorClass = dynamicTextColors?.headerTextColorClass || '';


  const getUserBalance = async () => {

    let response: any;
    try {
      response = await API.post(`/webapp/get-user-balance`, {
        userKey: sessionStorage.getItem("userKey"),
      });
    } catch (e) {
      return;
    }

    if (response.data.status !== "RS_OK") {
      toast.error(response.data.errDescription);
    }

    if (response && response.data.wallets) {
      setUserAllBalance(response.data?.wallets);
      setNonZeroBalance(response.data.wallets);
      setWallets(response.data?.wallets);
      setActiveWallet(response?.data?.activeWallet)
      setHasFetchedBalanceOnce(true);
      setWithdrawableAmount(response.data.withdrawableAmount ?? 0);
      setRedeemableBonus(response.data.redeemableBonus ?? 0);
      const matchingWallet = response.data.wallets.find(
        (wallet: any) => wallet?.walletName === response.data?.activeWallet
      );
      setSelectedBalance(matchingWallet);
    }
  };

  const getUserBalanceRef = useRef(getUserBalance);
  getUserBalanceRef.current = getUserBalance;

  const openNotificationLink = (link: string) => {
    if (link.startsWith("http")) {
      window.open(link, "_blank");
    } else {
      BannerNavigation(link, navigate);
    }
  };

  const handleWebSocketNotification = (event: WebSocketEvent) => {
    setHasNotifications(true);

    if (!event.text) {
      return;
    }

    showNotificationToast(event.text, {
      link: event.link,
      onLinkClick: openNotificationLink,
    });
  };

  const handleWebSocketNotificationRef = useRef(handleWebSocketNotification);
  handleWebSocketNotificationRef.current = handleWebSocketNotification;

  const changeActiveWallet = async (wallet: any) => {
    let response: any;
    try {
      response = await API.post(`/users/change-active-wallet`, {
        userKey: sessionStorage.getItem("userKey"),
        activeWallet: wallet?.walletName,
      });
    } catch (e) {
      return;
    }
    if (response.data?.status !== "RS_OK") {
      toast.error(response.data?.errorDescription);
    } else {
      getUserBalance();
    }
  }

  const getRefId = async () => {
    try {
      const userKey = sessionStorage.getItem("userKey");
      if (!userKey) {
        console.error("User ID not found in session storage");
        return;
      }
      const response = await API.post(`/users/get-user-details`, {
        userKey: userKey,
      });

      if (!response || response.data.status !== "RS_OK") {
        console.error("Error retrieving user details or invalid status");
        return;
      }

      const fetchedUserDetails: UserDetails = response.data?.userDetails;

      const validThemes = [
        'blue', 'purple', 'green', 'yellow', 'orange', // Existing themes
        'CSK', 'DC', 'GT', 'KKR', 'LSG', 'MI', 'PK', 'RR', 'RCB', 'SRH' // IPL Teams
      ] as const;
      type ThemeType = typeof validThemes[number];

      if (fetchedUserDetails) {
        setUserDetails(fetchedUserDetails);
        setUserThumbnail(fetchedUserDetails?.Thumbnail);
        if (validThemes.includes(fetchedUserDetails.Theme as ThemeType)) {
          setTheme(fetchedUserDetails.Theme as ThemeType);
        } else {
          setTheme('blue');
        }
      } else {
        console.error("User details not found in response");
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const setTheme = (themeName: keyof typeof themes) => {
    const selectedTheme = themes[themeName];

    if (selectedTheme) {
      loadColorConfig(selectedTheme)
    } else {
      console.error('Theme not found');
    }
  };

  const zeroBalance = () => {
    const filteredValue = userAllBalance?.filter((item: any) => item.balance > 0);
    if (hideZeroBalances) {
      setNonZeroBalance(filteredValue);
    } else {
      setNonZeroBalance(userAllBalance);
    }
    setHideZeroBalances(!hideZeroBalances)
  }

  const onCurrencyClick = (wallet: any) => {
    changeActiveWallet(wallet);
    setSelectedBalance(wallet);
    setShowBalInfo(false);
  }


  useEffect(() => {
    setHasFetchedBalanceOnce(false);
    getUserBalance();
    getNotifications();
    // getRefId();
  }, [])

  useEffect(() => {
    // Connect to notification WebSocket when userDetails is available
    const notificationWSBaseUrl = getNotificationWSBaseUrl();
    if (notificationWSBaseUrl && userDetails?.botId) {
      connectToNotificationWS(
        notificationWSBaseUrl,
        (event) => handleWebSocketNotificationRef.current(event),
        userDetails.botId,
        () => {
          if (!demoUser()) {
            void getUserBalanceRef.current();
          }
        }
      );
      notificationWSConnected.current = true;
    }
  }, [userDetails?.botId])

  useEffect(() => {
    const matchingWallet = wallets?.find(
      (wallet: any) => wallet?.walletName === activeWallet
    );
    setSelectedBalance(matchingWallet);
  }, [wallets])


  const dummyApi = async (dum: any) => {

    let response: any;
    try {
      response = await API.post(`/debug/debug-info`, {
        info: dum
      });

      console.log("resp", response.data)
    } catch (e) {
      return;
    }


  };

  useEffect(() => {
    if (!showContactBar) return;

    const handleOutside = (event: MouseEvent | TouchEvent) => {
      const barEl = contactBarRef.current;
      if (barEl && !barEl.contains(event.target as Node)) {
        setShowContactBar(false);
      }
    };

    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside, { passive: true });
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
    };
  }, [showContactBar]);

  useEffect(() => {
    if (!showNotificationPreview) return;

    const timer = setTimeout(() => {
      setShowNotificationPreview(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, [showNotificationPreview]);

  const getNotifications = async () => {
    let response: any;
    try {
      response = await API.post(`/users/get-web-notifications`, {
        page: 1,
        pageSize: 20,
        status: 'UNREAD',
        pageToken: '',
        userKey: sessionStorage.getItem("userKey"),
      });
    } catch (e) {
      console.error("Error fetching notifications:", e);
      return;
    }

    if (response.data.status !== "RS_OK") {
      return;
    }

    if (response && response.data?.notifications) {
      const notifications = response.data.notifications;
      const unreadCount = notifications.filter(
        (notif: any) => notif.status === "UNREAD"
      ).length;

      setUnreadNotificationCount(unreadCount);
      setHasNotifications(unreadCount > 0);
      setShowNotificationPreview(unreadCount > 0);
    } else {
      setUnreadNotificationCount(0);
      setHasNotifications(false);
      setShowNotificationPreview(false);
    }
  };

  const handleNotificationClick = () => {
    setShowNotificationPreview(false);
    setHasNotifications(false);
    setUnreadNotificationCount(0);
    navigate("/notifications");
  };

  const formatNotificationCount = (count: number) =>
    count > 9 ? "9+" : String(count);

  const getNotificationWSBaseUrl = (): string | null => {
    // Get WebSocket base URL - you may need to adjust this based on your API
    // For now, using the REST API base URL and converting to WebSocket
    try {
      const baseUrl = getBaseUrl(process.env.REACT_APP_NODE_ENV, "REACT_APP_REST_API_URL");
      // Convert REST API URL to WebSocket URL
      // Example: https://stage-core.stwin2025.co/api/v1 -> https://stage-core.stwin2025.co/api/v1/ws/notification
      const wsUrl = baseUrl.replace(/\/api\/v1\/?$/, "/api/v1/ws/notification");
      return wsUrl;
    } catch (e) {
      console.error("Error getting notification WebSocket URL:", e);
      return null;
    }
  };

  return (
    <>
      <div className={`fixed flex flex-col justify-center px-4 py-3 w-full text-sm font-medium whitespace-nowrap bg-header-color z-50 wallet-info max-h-[3.75rem] ${headerTextColorClass}`}>
        <div className="flex justify-between w-full">
          <div className="flex w-[27%] items-center justify-start gap-1 relative">
            <img
              loading="lazy"
              src={WhiteLabelLogo}
              alt=""
              className="rounded-none max-h-[3.5rem]"
            />
          </div>
          {/* <SupportAgentIcon /> */}
          <div className="flex gap-3 justify-between w-full items-center">
            {/* Hide support icons for Khelo365days - they have WhatsApp icon above footer */}
            {BRAND_NAME?.toLowerCase() !== 'khelo365days' ? (
            <div className="flex items-center gap-1">
              {isWhatsAppPriorityBrand && siteConfig?.contactInfo?.WhatsappSupport ? (
                <FaWhatsapp
                  size={24}
                  className="text-[#25D366] hover:text-green-800 cursor-pointer transition"
                  onClick={() => {
                    try {
                      const raw = siteConfig.contactInfo.WhatsappSupport.trim();
                      const link = raw.startsWith("http")
                        ? raw
                        : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;
                      if (window.Telegram?.WebApp?.openLink) {
                        window.Telegram.WebApp.openLink(link);
                      } else {
                        window.open(link, "_blank");
                      }
                    } catch (err) {
                      console.warn("WhatsApp link blocked or invalid:", err);
                    }
                  }}
                />
              ) : siteConfig?.contactInfo?.EnableCustomerSupport ? (
                <NavLink to="/customersupport">
                  <img src={SupportIcon} alt=""
                    className="w-9 aspect-square cursor-pointer"
                    style={{ 
                      filter: path === "/customersupport" 
                        ? 'var(--filter-color)' 
                        : headerTextColorClass === 'dark-text'
                          ? "invert(0%)"
                          : "invert(100%) sepia(100%) saturate(0%) hue-rotate(139deg) brightness(110%) contrast(101%)"
                    }}
                  />
                </NavLink>
              ) : siteConfig?.contactInfo?.WhatsappSupport ? (
                <FaWhatsapp
                  size={24}
                  className="text-[#25D366] hover:text-green-800 cursor-pointer transition"
                  onClick={() => {
                    try {
                      const raw = siteConfig.contactInfo.WhatsappSupport.trim();
                      const link = raw.startsWith("http")
                        ? raw
                        : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;
                      if (window.Telegram?.WebApp?.openLink) {
                        window.Telegram.WebApp.openLink(link);
                      } else {
                        window.open(link, "_blank");
                      }
                    } catch (err) {
                      console.warn("WhatsApp link blocked or invalid:", err);
                    }
                  }}
                />
              ) : siteConfig?.contactInfo?.TelegramChannel ? (
                <FaTelegramPlane
                  size={22}
                  className="text-[#0088cc] hover:text-sky-400 cursor-pointer transition"
                  onClick={() => {
                    const tg = siteConfig.contactInfo.TelegramChannel.trim();
                    let link = tg;
                    if (!tg.startsWith('t.me')) {
                      link = `t.me/${tg}`;
                    }
                    window.open(`//${link}`, '_blank'); 
                  }}
                />
              ) : null}
              {siteConfig?.contactInfo &&
                Object.values(siteConfig.contactInfo).some(
                  (v) => typeof v === "string" && v.trim() !== ""
                ) && (
                  <FaChevronDown
                    size={13}
                    className={`mt-[2px] transition cursor-pointer ${headerTextColorClass} ${
                      showContactBar
                        ? "rotate-180"
                        : ""
                    }`}
                    onClick={() => setShowContactBar((prev) => !prev)}
                  />
                )}
            </div>
            ): (<>
            <div className="mr-1"></div>
            </>)}
            {isDualWalletBalanceBrand ? (
            <div className="flex flex-col justify-center rounded-lg w-fit sm:w-auto sm:min-w-[240px] sm:max-w-[360px]">
              <div className={`flex flex-col justify-center px-1.5 sm:px-3 py-1.5 sm:py-2 w-fit sm:w-full rounded-lg border border-solid bg-inputbox-color border-slate-800 ${inputBoxTextColorClass}`}
              >
                <div className="flex items-start gap-2 w-full justify-between">
                  <div
                    className={`text-xs ${inputBoxTextColorClass} flex flex-col sm:flex-row sm:flex-1 sm:items-center sm:justify-between sm:gap-6`}
                  >
                    {/* Mobile: stacked rows */}
                    <div className="sm:hidden inline-flex flex-col">
                      {balWallet && (
                        <div className="grid grid-cols-[72px_auto] items-center gap-1.5 w-full leading-tight">
                          <span className="whitespace-nowrap">{balWallet.walletTitle || "BAL"}:</span>
                          <span className="tabular-nums text-right whitespace-nowrap">
                            {balWallet.balance}
                          </span>
                        </div>
                      )}

                      {balWallet && secondaryWallet && (
                        <div className="h-px w-full bg-[var(--border-color)] opacity-60 my-1" />
                      )}

                      {secondaryWallet && (
                        <div className="grid grid-cols-[72px_auto] items-center gap-1.5 w-full mt-0.5 leading-tight">
                          <span className="whitespace-nowrap">{secondaryWallet.walletTitle || "CHIPS"}:</span>
                          <span className="tabular-nums text-right whitespace-nowrap">
                            {secondaryWallet.balance}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Desktop: single horizontal row */}
                    {balWallet && (
                      <div className="hidden sm:flex items-center gap-2 min-w-0">
                        {balWallet.walletIcon ? (
                          <img
                            loading="lazy"
                            src={balWallet.walletIcon}
                            alt=""
                            className="shrink-0 aspect-square w-[16px]"
                          />
                        ) : null}
                        <span className="whitespace-nowrap">{balWallet.walletTitle || "BAL"}:</span>
                        <span className="tabular-nums whitespace-nowrap">
                          {balWallet.balance}
                        </span>
                      </div>
                    )}

                    {secondaryWallet && (
                      <div className="hidden sm:flex items-center gap-2 min-w-0">
                        {secondaryWallet.walletIcon ? (
                          <img
                            loading="lazy"
                            src={secondaryWallet.walletIcon}
                            alt=""
                            className="shrink-0 aspect-square w-[16px]"
                          />
                        ) : (
                          <StarRoundedIcon sx={{ fontSize: 16 }} />
                        )}
                        <span className="whitespace-nowrap">{secondaryWallet.walletTitle || "CHIPS"}:</span>
                        <span className="tabular-nums whitespace-nowrap">
                          {secondaryWallet.balance}
                        </span>
                      </div>
                    )}
                  </div>

                  <IconButton
                    size="small"
                    aria-label="Balance info"
                    onClick={() => setShowBalInfo(true)}
                    className={inputBoxTextColorClass}
                    sx={{
                      padding: "1px",
                      alignSelf: "center",
                      color: "inherit",
                    }}
                  >
                    <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </div>
              </div>
            </div>
            ) : (
              <div className="flex flex-col justify-center rounded-lg w-[60%]">
                <div
                  className={`flex flex-col justify-center px-3 py-2 w-full rounded-lg border border-solid bg-inputbox-color border-slate-800 ${inputBoxTextColorClass}`}
                >
                  <div className="flex items-center gap-1.5 w-full justify-between cursor-pointer">
                    <img
                      loading="lazy"
                      src={selectedBalance?.walletIcon}
                      alt=""
                      className="shrink-0 my-auto aspect-square w-[18px]"
                    />
                    <div
                      className={`flex items-center justify-between text-xs w-full ml-2 ${inputBoxTextColorClass}`}
                      onClick={() => setShowBalInfo(true)}
                    >
                      <div className={`flex ${inputBoxTextColorClass}`}>
                        {selectedBalance?.walletTitle}:{" "}
                        {selectedBalance?.balance ? selectedBalance?.balance : 0}
                      </div>
                      <img
                        loading="lazy"
                        src={DownArrow}
                        alt=""
                        className={`shrink-0 my-auto w-2.5 aspect-[1.67] ${
                          inputBoxTextColorClass === "dark-text"
                            ? "text-black"
                            : "text-white"
                        }`}
                        style={{
                          filter:
                            inputBoxTextColorClass === "dark-text"
                              ? "brightness(0)"
                              : "brightness(0) invert(1)",
                          color:
                            inputBoxTextColorClass === "dark-text"
                              ? "#000000"
                              : "#FFFFFF",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="notification-bell-wrap" ref={notificationBellRef}>
                <FaBell
                  size={22}
                  className={`${headerTextColorClass} hover:opacity-70 cursor-pointer transition`}
                  onClick={handleNotificationClick}
                  aria-label={t("notifications.title")}
                />
                {hasNotifications && (
                  <span className="notification-bell-dot" aria-hidden="true" />
                )}
                {showNotificationPreview && unreadNotificationCount > 0 && (
                  <button
                    type="button"
                    className="notification-preview-popover"
                    onClick={handleNotificationClick}
                    aria-label={t("notifications.title")}
                  >
                    <span className="notification-preview-popover__caret" aria-hidden="true" />
                    <span className="notification-preview-popover__count">
                      {formatNotificationCount(unreadNotificationCount)}
                    </span>
                  </button>
                )}
              </div>
            <NavLink to="/profile" className="shrink-0">
              <img
                loading="lazy"
                src={userThumbnail === "" ? ProfileImg : userThumbnail}
                alt={t("wallet.profile")}
                className="w-9 rounded-full aspect-square cursor-pointer"
              />
            </NavLink>
          </div>
        </div>
      </div>

      {
        showContactBar &&
        siteConfig?.contactInfo &&
        Object.values(siteConfig.contactInfo).some(
          (v) => typeof v === "string" && v.trim() !== ""
        ) && (
          <div
            className="fixed top-[60px] left-0 flex justify-center items-center gap-6 bg-[#0a0f1f] text-white py-2 border-t border-[#1e2a3a] w-full z-40 transition-all duration-300 animate-fadeIn"
            ref={contactBarRef}
          >
            {/* 🔹 Telegram */}
            {(siteConfig?.contactInfo?.EnableCustomerSupport ||
            siteConfig?.contactInfo?.WhatsappSupport) &&
            siteConfig?.contactInfo?.TelegramChannel && (
              <FaTelegramPlane
                size={22}
                className="text-[#38bdf8] hover:text-sky-400 cursor-pointer transition"
                onClick={() => {
                  const tg = siteConfig.contactInfo.TelegramChannel.trim();
                  let link = tg;
                  if (!tg.startsWith('t.me')) {
                    link = `t.me/${tg}`;
                  }
                  window.open(`//${link}`, '_blank'); 
                }}
              />
            )}

            {/* 🔹 WhatsApp */}
            {siteConfig.contactInfo.WhatsappSupport && siteConfig.contactInfo.EnableCustomerSupport &&(
              <FaWhatsapp
                size={22}
                className="text-[#25D366] hover:text-green-400 cursor-pointer transition"
                onClick={() => {
                  try {
                    const raw = siteConfig.contactInfo.WhatsappSupport.trim();
                    const link = raw.startsWith("http")
                      ? raw
                      : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;

                    if (window.Telegram?.WebApp?.openLink) {
                      window.Telegram.WebApp.openLink(link);   // ✅ opens in system browser
                    } else {
                      window.open(link, "_blank");             // ✅ fallback for normal browsers
                    }
                  } catch (err) {
                    console.warn("WhatsApp link blocked or invalid:", err);
                  }
                }}
              />
            )}

            {/* 🔹 Instagram */}
            {siteConfig.contactInfo.Instagram && (
              <FaInstagram
                size={22}
                className="text-[#E1306C] hover:text-pink-500 cursor-pointer transition"
                onClick={() => {
                  try {
                    const raw = siteConfig.contactInfo.Instagram.trim();
                    const link = raw.startsWith("http")
                      ? raw
                      : `https://instagram.com/${raw}`;
                    if (window.Telegram?.WebApp?.openLink) {
                      window.Telegram.WebApp.openLink(link);
                    } else {
                      window.open(link, "_blank");
                    }
                  } catch (err) {
                    console.warn("Instagram link blocked or invalid:", err);
                  }
                }}
              />
            )}

            {/* 🔹 Facebook */}
            {siteConfig.contactInfo.Facebook && (
              <FaFacebook
                size={22}
                className="text-[#1877F2] hover:text-blue-400 cursor-pointer transition"
                onClick={() => {
                  try {
                    const raw = siteConfig.contactInfo.Facebook.trim();
                    const link = raw.startsWith("http")
                      ? raw
                      : `https://facebook.com/${raw}`;
                    if (window.Telegram?.WebApp?.openLink) {
                      window.Telegram.WebApp.openLink(link);
                    } else {
                      window.open(link, "_blank");
                    }
                  } catch (err) {
                    console.warn("Facebook link blocked or invalid:", err);
                  }
                }}
              />
            )}
          </div>
        )}
      {
        showBalInfo && (
          <Dialog
            fullScreen={false}
            open={showBalInfo}
            onClose={() => setShowBalInfo(false)}
            PaperProps={{
              style: {
                position: 'absolute',
                top: '2rem'
              }
            }}
          >
            <div className={`dialog-bg bg-inputbox-color ${inputBoxTextColorClass}`}>
              <div>
                {
                  nonZeroBalance?.map((wallet: any) => {
                    const walletDisplayLabel = wallet?.walletTitle || "";
                    return (
                      <>
                        <div className={`main-section ${wallet?.walletTitle === selectedBalance?.walletTitle ? "selected-bal-bg" : ""} ${inputBoxTextColorClass}`}
                          onClick={() => onCurrencyClick(wallet)}
                        >
                          <div style={{ display: "flex" }}>
                            <div>
                              <img
                                src={wallet?.walletIcon}
                                alt="icon"
                                style={{ 
                                  height: '1rem', 
                                  marginRight: '5px',
                                  filter: inputBoxTextColorClass === 'dark-text' ? "invert(0%)" : "invert(100%)"
                                }}
                              />
                            </div>
                            <div className={inputBoxTextColorClass}>
                              {walletDisplayLabel}
                            </div>
                          </div>
                          <div className={inputBoxTextColorClass} style={{ display: 'flex', justifyContent: 'space-between', width: '65%' }}>
                            <div>
                              {t("common.balance")}: {wallet?.balance}
                            </div>
                            <div>
                              {t("common.exposure")}: {wallet?.exposure}
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })
                }
              </div>
              <div className="sec-divider"></div>
              {hasPlayChipsWallet && (
                <div className={`text-xs mb-4 ${inputBoxTextColorClass}`}><b>{t("wallet.note")} </b> {t("wallet.playChipsNote")}
                </div>
              )}
              <button
                type="button"
                className={`balance-action-button ${inputBoxTextColorClass}`}
                onClick={() => {
                  setShowBalInfo(false);
                  navigate("/wallet", { state: { tab: "wallet" } });
                }}
              >
                <span className="balance-action-label">
                  <span className="balance-action-icon">
                    {balWallet?.walletIcon ? (
                      <img
                        src={balWallet.walletIcon}
                        alt="icon"
                        style={{
                          height: '1rem',
                          marginRight: '5px',
                          filter: inputBoxTextColorClass === 'dark-text' ? "invert(0%)" : "invert(100%)"
                        }}
                      />
                    ) : null}
                  </span>
                  <span className="balance-action-copy">
                    <span className="balance-action-subtitle">
                      <span>WITHDRAWABLE AMOUNT</span>
                      <span className="balance-action-value tabular-nums">
                        <span className="balance-action-value-highlight">{withdrawableAmount}</span>
                      </span>
                    </span>
                  </span>
                </span>
                <span className="balance-action-meta">
                  <span className="balance-action-go">
                  View
                  </span>
                </span>
              </button>
              <button
                type="button"
                className={`balance-action-button ${inputBoxTextColorClass}`}
                onClick={() => {
                  setShowBalInfo(false);
                  navigate("/wallet", { state: { tab: "bonus" } });
                }}
              >
                <span className="balance-action-label">
                  <span className="balance-action-icon">
                    {playChipsWallet?.walletIcon ? (
                      <img
                        src={playChipsWallet.walletIcon}
                        alt="icon"
                        style={{
                          height: '1rem',
                          marginRight: '5px',
                          filter: inputBoxTextColorClass === 'dark-text' ? "invert(0%)" : "invert(100%)"
                        }}
                      />
                    ) : (
                      <StarRoundedIcon sx={{ fontSize: 16, marginRight: "5px" }} />
                    )}
                  </span>
                  <span className="balance-action-copy">
                    <span className="balance-action-subtitle">
                      <span>REDEEMABLE BONUS</span>
                      <span className="balance-action-value tabular-nums">
                        <span className="balance-action-value-highlight">{redeemableBonus}</span>
                      </span>
                    </span>
                  </span>
                </span>
                <span className="balance-action-meta">
                  <span className="balance-action-go">
                    View
                  </span>
                </span>
              </button>
            </div>
          </Dialog>
        )
      }
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    userDetails: state.userDetails?.userDetails,
    wallets: state.userDetails?.wallets,
    activeWallet: state.userDetails?.activeWallet,
    userThumbnail: state.userDetails?.Thumbnail,
    Browser: state.userDetails?.Browser,
    siteConfig: state.userDetails?.siteConfig,
    dynamicTextColors: state.userDetails?.dynamicTextColors,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setUserDetails: (data: any) => {
      dispatch(setUserDetails(data));
    },
    setWallets: (data: any) => {
      dispatch(setWallets(data));
    },
    setActiveWallet: (data: any) => {
      dispatch(setActiveWallet(data));
    },
    setUserThumbnail: (data: any) => {
      dispatch(setUserThumbnail(data));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WalletInfo);
